import React from 'react';
import classNames from 'classnames';
import {
  CLEAR_INPUT_BUTTON_WRAPPER_CLASS,
  CLEAR_INPUT_BUTTON_CLASS,
  INPUT_BUTTON_SEPARATOR_CLASS,
  TOGGLE_LIST_BUTTON_WRAPPER_CLASS,
  TOGGLE_LIST_BUTTON_CLASS,
} from './ComboBoxClasses';

interface ComboBoxButtonsProps {
  clearInput: VoidFunction;
  toggleList: VoidFunction;
  disabled?: boolean;
  className?: string;
}

const ComboBoxButtons = ({ clearInput, toggleList, disabled, className }: ComboBoxButtonsProps): JSX.Element => (
  <>
    <span className={CLEAR_INPUT_BUTTON_WRAPPER_CLASS} tabIndex={-1}>
      <button
        type="button"
        className={classNames(className, CLEAR_INPUT_BUTTON_CLASS)}
        aria-label="Clear the select contents"
        onClick={clearInput}
        disabled={disabled}
        hidden={disabled}
      >
        &nbsp;
      </button>
    </span>
    <span className={INPUT_BUTTON_SEPARATOR_CLASS}>&nbsp;</span>
    <span className={TOGGLE_LIST_BUTTON_WRAPPER_CLASS} tabIndex={-1}>
      <button
        type="button"
        tabIndex={-1}
        className={classNames(className, TOGGLE_LIST_BUTTON_CLASS)}
        aria-label="Toggle the dropdown list"
        onClick={toggleList}
        disabled={disabled}
      >
        &nbsp;
      </button>
    </span>
  </>
);

export default ComboBoxButtons;
